<template>
  <b-modal id="BSFindSnelstartOpdrachtgeverID" centered size="lg" @show="clear">
    <template #modal-header>
      <h2 class="modal-title">Koppel Snelstart {{ company.company_name }}</h2>
      {{ company_id }}
    </template>
    <form class="form">
      <div class="form-row">
        <div class="col-3">
          <label for="">Relatiecode</label>
        </div>
        <div class="col">
          <b-input-group class="mt-3">
            <b-form-input :type="text" v-model="relatiecode" placeholder="" />
          </b-input-group>
        </div>
      </div>
      <div v-if="companyname != ''" class="row">
        <div class="col-3">{{ $t("labels.companyname") }}</div>
        <div class="col-9">{{ companyname }}</div>
        <div class="col-3">{{ $t("labels.kvk") }}</div>
        <div class="col-9">{{ kvk }}</div>
      </div>
      <div v-if="error != ''" class="row">
        <div class="col-3"></div>
        <div class="col-9">{{ $t("labels.invalid_token") }}</div>
      </div>
    </form>

    <template #modal-footer>
      <div @click="close_modal" class="btn btn-secondary">
        {{ $t("buttons.close") }}
      </div>
      <div @click="finduser" class="btn btn-primary">
        {{ $t("labels.search") }}
      </div>
      <div v-if="companyname != ''" @click="saveuser()" class="btn btn-primary">
        {{ $t("buttons.saveandclose") }}
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import axios from "axios";

export default {
  name: "invoice-data-modal",
  data() {
    return {
      relatiecode: null,
      companyname: "",
      kvk: "",
      result: null,
      error: "",
    };
  },
  props: {
    company_id: Number,
  },
  computed: {
    ...mapState([]),
    ...mapGetters(["company_by_id"]),
    company() {
      return this.company_by_id(this.company_id);
    },
  },
  methods: {
    clear() {
      this.relatiecode = null;
    },
    ...mapActions(["save_company"]),
    async finduser() {
      this.error = "";
      await axios
        .get("/api/snelstart_get_relatie", {
          params: {
            id: this.relatiecode,
          },
        })
        .then((response) => {
          console.log("snelstart_get_relatie", response.data);
          if (response.data.length > 1) {
            if (response.data[0].relatiesoort[0] == "Klant") {
              this.companyname = response.data[0].naam;
              this.kvk = response.data[0].kvkNummer;
              this.result = response.data[0];
            } else {
              this.companyname = response.data[1].naam;
              this.kvk = response.data[1].kvkNummer;
              this.result = response.data[1];
            }
          } else {
            this.companyname = response.data[0].naam;
            this.kvk = response.data[0].kvkNummer;
            this.result = response.data[0];
          }
        })
        .catch((error) => {
          console.log(">S>S>", error);
          this.error = "NOTFound";
        });
    },
    saveuser() {
      this.company_by_id(this.company_id).debnum = this.result.id;
      this.save_company(this.company_id);
      this.$bvModal.hide("BSFindSnelstartOpdrachtgeverID");
    },
    close_modal() {
      this.$bvModal.hide("BSFindSnelstartOpdrachtgeverID");
    },
  },
};
</script>
